export class RequestBody{
     payload:any;
     function:string;  
     userName:any;  
}